<template>
<aside class="menu sidebar">
    <p class="menu-label has-text-white">Navigastion</p>
    <ul class="menu-list">
      <li>
        <a href="#" :class="{ 'is-active': activeNum == 1 }" @click="changeActiveLink(1)">
          作ったもの
        </a>
        <ul>
          <li>
            <a href="https://twistock.interimadd.com/">
              Twistock
            </a>
          </li>
          <li>
            <router-link to="/works/css_nixietube" :class="{ 'is-active': activeNum == 30 }" @click.native="changeActiveLink(30)">
              CSSニキシー管
            </router-link>
          </li>
        </ul>
      </li>
      <li>
        <router-link to="/blog" :class="{ 'is-active': activeNum == 2 }" @click.native="changeActiveLink(2)">
          ブログ
        </router-link>
        <ul>
          <li v-for="(post,index) in posts" :key="post.id + '_' + index">
            <router-link v-bind:to="'/blog/'+ post.id" :class="{ 'is-active': activeNum == 20+index }" @click.native="changeActiveLink(20+index)">
              <div class="is-size-7">{{ post.title}} </div>
            </router-link>
          </li>
        </ul>
      </li>
    </ul>
</aside>
</template>

<script>
import axios from "axios";

export default {
  data () {
    return {
      activeNum: 0,
      posts: []
    }
  },
  async mounted() {
    // 記事を取得する
    const response = await axios.get(
      "https://interimadd.microcms.io/api/v1/articles?fields=id,title",
      {
        headers: { "X-API-KEY": process.env.VUE_APP_MICRO_CMS_API_KEY }
      }
    );
    this.posts = response.data.contents;
  },
  methods: {
    changeActiveLink (n) {
      this.activeNum = n
    }
  }
}
</script>

<style lang="scss">
.sidebar{
  width: 15em;
  min-height: 94.5vh;
  height: auto;
  padding: 1.5em;
  margin-top: 2em;
}
</style>